import { Row, Typography } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface UserIsBlockecModalComponent {
    isOpen: boolean;
    onClose: () => void;
    unblockFan?: () => void;
    isFromConversation?: boolean
}

const UserIsBlockedModalComponent: React.FC<UserIsBlockecModalComponent> = ({
    isOpen,
    onClose,
    unblockFan,
    isFromConversation = false
}) => {
    const { t } = useTranslation();

    useEffect(() => {
        const preventTouchMove = (e: Event) => {
            e.preventDefault();
        };
        if (isOpen) {
            document.body.addEventListener("touchmove", preventTouchMove, { passive: false });
        } else {
            document.body.removeEventListener("touchmove", preventTouchMove);
        }
        return () => {
            document.body.removeEventListener("touchmove", preventTouchMove);
        };
    }, [isOpen]);
    

    if (!isOpen) return null;

    const handleOverlayClick = () => onClose();
    const handleModalClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    };

    return (
        <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
            <div className="bottom-modal-content" onClick={handleModalClick}>
                <Row className="w-full justify-content-center mt-10">
                    <div className="header-icon-grey" onClick={handleOverlayClick}></div>
                </Row>

                <div className="bottom-modal-container">
                    <div className="bottom-modal-title-wrapper">
                        <div className="bottom-modal-title">{isFromConversation ? t("fan-blocked-title") : t("unblock-this-fan-title")}</div>
                    </div>

                    <div className="bottom-modal-buttons-wrapper">
                        <button
                            className="bottom-modal-button mt-14"
                            onClick={unblockFan}
                        >
                            <Typography.Text className="bottom-modal-button-title">{t("unblock")}</Typography.Text>
                        </button>

                        <button className="cancel-button" onClick={onClose}>
                            <Typography.Text className="cancel-button-title">{t("cancel")}</Typography.Text>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserIsBlockedModalComponent;
